import { Grid } from '@mui/material';
import { GridOwnProps } from '@mui/material/Grid/Grid';
import React from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface GridContainerProps extends Omit<GridOwnProps, 'container'> {
    sx?: SxProps<Theme>;
}

const GridContainer: React.FC<GridContainerProps> = ({ children, sx, ...props }) => {
    return (
        <Grid container spacing={1} rowGap={2} sx={sx} {...props}>
            {children}
        </Grid>
    );
};

export default GridContainer;
